const LOOP_DETECTION = {
  requestTimestamps: new Map(),
  THRESHOLD: 20,
  WINDOW_MS: 2 * 60 * 1000, // 2 minutes
};

export const detectLoopedRequests = (endpoint) => {
  const now = Date.now();

  const timestamps = LOOP_DETECTION.requestTimestamps.get(endpoint) || [];

  const recentTimestamps = timestamps.filter(
    (timestamp) => now - timestamp < LOOP_DETECTION.WINDOW_MS,
  );

  recentTimestamps.push(now);

  LOOP_DETECTION.requestTimestamps.set(endpoint, recentTimestamps);

  if (recentTimestamps.length >= LOOP_DETECTION.THRESHOLD) {
    const errorMessage = `loop detected: ${recentTimestamps.length} requests to ${endpoint} in ${LOOP_DETECTION.WINDOW_MS / 60} mins`;

    const { captureException } = globalThis?.Sentry || {};
    if (captureException) {
      captureException(new Error(errorMessage), {
        extra: {
          endpoint,
          infiniteLoop: true,
          requestCount: recentTimestamps.length,
          timestamps: recentTimestamps,
          timeWindow: LOOP_DETECTION.WINDOW_MS,
          url: globalThis?.location?.href,
          userAgent: globalThis?.navigator?.userAgent,
        },
        fingerprint: ['loop', endpoint],
        level: 'warning',
        tags: {
          endpoint,
        },
      });
    }

    LOOP_DETECTION.requestTimestamps.set(endpoint, []);
  }
};
